import React, { useState } from 'react';
import { debounce } from 'lodash/fp';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import request from 'utils/request_ajax';
import QuestionPrompt from 'components/Practice/Learner/QuestionPrompt';
import QuestionElementPrompt from 'components/Questions/shared/QuestionElementPrompt';
import HighFiveShareableLink from 'components/shared/HighFiveShareableLink';
import ReplyContainer from '../Practice/Learner/ReplyContainer';

const ChatPracticeQuestion = props => {
  const { data, meta, i18n } = props;
  const [answerPresent, setAnswerPresent] = useState(!!data.givenAnswer);

  const saveAnswer = answer => {
    const answerData = { answer, question_id: data.questionId };
    request.post(meta?.saveUrl, answerData).then(() => {
      setAnswerPresent(!!answer);
    });
  };
  const isDisabled = meta.finished || meta.previewing;

  return (
    <div className="bdrs-base PracticeQuestion">
      <>
        <QuestionElementPrompt
          required={data.required}
          subject={data.subject}
          questionSubjectClass={meta.questionSubjectClass}
          labelErrorClass={meta.labelErrorClass}
          isGradable={data.isGradable}
          elementHeaderClass={meta.elementHeaderClass}
          isPractice={data.isPractice}
        />
        {meta?.features?.practice && data.criteria.length > 0 && (
          <QuestionPrompt criteria={data.criteria} features={meta.features} />
        )}
        <div className="PracticeQuestion-response">
          <div className="mb-16">
            <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
              {i18n?.chat.instructions}
            </Text>
          </div>
          <ReplyContainer
            previewing={meta.previewing}
            givenAnswer={data.givenAnswer}
            questionType={data.questionType}
            questionChatData={data.questionChatData}
            isDisabled={isDisabled}
            i18n={i18n?.chat}
            placeholder={i18n?.chat.reply_to}
            updateMessage={debounce(300, saveAnswer)}
          />
          <HighFiveShareableLink
            questionId={data.questionId}
            progressId={data.progressId}
            hasAnswerBeenSubmitted={answerPresent}
            isGradable={data.isGradable}
          />
        </div>
      </>
    </div>
  );
};

export default ChatPracticeQuestion;
